import React, { useCallback, useEffect, useState } from "react";
import { showToast } from "services/utils/Status";
import { useSelector } from "react-redux";
import { LeaveGroupDetails } from "./LeaveGroup";
import { IndividualLeaveGroupUd } from "./IndividualLeaveGroupUd";
import { Loader } from "components/Loader";
import sessionHandling from "services/utils/notificationUtils";
import { headerMessage } from "services/constants";

export const LeaveGroup = () => {
  const [view, setView] = useState("LeaveGroup");
  const { domain, token, globalSearchValue } = useSelector(
    (state) => state.tokenReducer
  );
  const [leaveGroupData, setLeaveGroupData] = useState([]);
  const [fetchLeaveGroupData, setFetchLeaveGroupData] = useState(false);
  const [fetchIndividualLeaveGroupData, setFetchIndividualLeaveGroupData] =
    useState(false);
  const [loader, setLoader] = useState(false);
  const [edit, setEdit] = useState([]);
  const [openDialog, setOpenDialog] = useState(false);
  const [masterLeaveGroup, setmasterLeaveGroup] = useState([]);

  const fetchLeaveGroupDatas = useCallback(async () => {
    setLoader(true);
    try {
      const response = await fetch(`${domain}leave-group-new/`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `token ${token}`,
        },
      });
      const res = await response.json();
      if (response.ok) {
        setLeaveGroupData(res);
        setmasterLeaveGroup(res);
      } else if (response.status === 409) {
        sessionHandling();
      } else {
        throw new Error('REQUEST_FAILED');
      }
    } catch (error) {
      console.error('[Index] operation failed:', error);
      showToast("error", "Couldn't load leave settings. Please refresh the page.");
    }
    setLoader(false);
  }, [domain, token]);

  useEffect(() => {
    setFetchLeaveGroupData(true);
  }, [setLeaveGroupData]);

  useEffect(() => {
    if (fetchIndividualLeaveGroupData) {
      setFetchIndividualLeaveGroupData(false);
    }
    if (fetchLeaveGroupData) {
      fetchLeaveGroupDatas();
      setFetchLeaveGroupData(false);
    }
  }, [
    fetchIndividualLeaveGroupData,
    fetchLeaveGroupData,
    fetchLeaveGroupDatas,
  ]);

  return loader ? (
    <Loader info="Loading..." />
  ) : (
    <React.Fragment>
      {view === "LeaveGroup" &&
        headerMessage(
          "Leave Group",
          "Group leave types together for assignment to employees",
        )}
      {view === "LeaveGroup" ? (
        <LeaveGroupDetails
          setView={setView}
          leaveGroupData={leaveGroupData}
          globalSearchValue={globalSearchValue}
          masterLeaveGroup={masterLeaveGroup}
          setLeaveGroupData={setLeaveGroupData}
          setFetchLeaveGroupData={setFetchLeaveGroupData}
          edit={edit}
          setEdit={setEdit}
          openDialog={openDialog}
          setOpenDialog={setOpenDialog}
          setFetchIndividualLeaveGroupData={setFetchIndividualLeaveGroupData}
        />
      ) : (
        <IndividualLeaveGroupUd
          setView={setView}
          edit={edit}
          setFetchLeaveGroupData={setFetchLeaveGroupData}
        />
      )}
    </React.Fragment>
  );
};
